import Config from "../Config";

import "../assets/scss/components/_klarna-cta.scss";
import type { KlarnaCTAProps } from "../types/components/KlarnaCTAProps";

const parseKlarnaAmount = (amount) => {
	return parseFloat(amount)
		.toString()
		.replace(/[^0-9]+/g, "");
};

export const KlarnaCTA = ({
	cta = "",
	theme = "default",
	purchaseAmount = null,
	managePaymentsLink = false,
}: KlarnaCTAProps) => {
	if (!Config.paymentMethodsEnabled?.klarnaEnabled) {
		return null;
	}

	if (!cta) {
		return null;
	}

	return (
		<div className={`klarna-cta ${cta}`}>
			<klarna-placement
				data-locale="en-GB"
				data-key={cta}
				{...(purchaseAmount ? { "data-purchase-amount": parseKlarnaAmount(purchaseAmount) } : {})}
				{...(theme === "default" ? { "data-theme": "default" } : {})}
			/>
			{managePaymentsLink && (
				<a href="https://app.klarna.com/" target="_blank">
					Manage Payments
				</a>
			)}
		</div>
	);
};
